import React from 'react';
import PropTypes from 'prop-types';

import Summary from './Summary';
import ScatterPlot from './ScatterPlot';

const NumericalComponent = props =>
  <div className="flex" id="bottom-pane">
    <div className="half mr-15" id="original-dataset">
      <div className="content-item">
        <div className="flex space-between">
          <p className="font-700 mb-10">
            Original Dataset’s Scatter Plot
          </p>
        </div>

        <div className="mb-30">
          <ScatterPlot
            dotFillColor="darkblue"
            dots={props.datasetDots}
            originalDots={props.sampleDots}
            xAxisLabel={props.primaryParameterName}
            yAxisLabel={props.secondaryParameterName}
          />
        </div>

        <Summary
          dots={props.datasetDots}

          slopeLabel="Slope"
          interceptLabel="Intercept"
          correlationLabel="Correlation"
          numberOfSamplesLabel="Total Number of Observations"
        />
      </div>
    </div>

    <div className="half" id="sample-dataset">
      <div className="content-item">
        <div className="flex space-between">
          <p className="font-700 mb-10">
            Permutated Sample’s Scatter Plot
          </p>
        </div>

        <div className="mb-30">
          <ScatterPlot
            dots={props.sampleDots}
            originalDots={props.datasetDots}
            xAxisLabel={props.primaryParameterName}
            yAxisLabel={props.secondaryParameterName}
          />
        </div>

        <Summary
          dots={props.sampleDots}

          slopeLabel="Sample's Slope"
          interceptLabel="Sample's Intercept"
          correlationLabel="Sample's Correlation"
          numberOfSamplesLabel="Sample's Number of Observations"
        />
      </div>
    </div>
  </div>;

NumericalComponent.propTypes = {
  datasetDots: PropTypes.arrayOf(
    PropTypes.array.isRequired
  ).isRequired,

  sampleDots: PropTypes.arrayOf(
    PropTypes.array.isRequired
  ).isRequired,

  primaryParameterName: PropTypes.string.isRequired,
  secondaryParameterName: PropTypes.string.isRequired
};

export default NumericalComponent;
